import m from 'mithril'


//Models
import Authors from '../../../models/Authors'
import Genres from '../../../models/Genres'


//Constants
const image_base = 'https://libraryofshortstories.s3.ap-southeast-2.amazonaws.com/small/'
import { capitalise_first } from '../../../logic/Formatter'


const author_tile = {
    view: vnode => {

        let author = vnode.attrs.author
        return [
            m('.author_cluster',
                {
                    key: author.code,
                    class: `${vnode.attrs.restricted ? 'restricted' : ''} ${vnode.attrs.inspecting ? 'inspecting' : ''}`,
                    onclick: vnode.attrs.restricted ? (e) => {
                        vnode.attrs.inspect()
                        e.preventDefault()
                        return false
                    } : undefined

                },

                m('a.author_tile',
                    {
                        href: author.code ? ('/author/' + author.code) : '',
                        oncreate: vnode_inner => {
                            if (vnode.attrs.inspecting) {
                                vnode_inner.dom.focus()
                            }
                        },
                        onmouseenter: () => {
                            vnode.state.hovering_main_tile = true
                        },
                        onmouseleave: () => {
                            vnode.state.hovering_main_tile = false
                        },
                    },


                    m('.author_tile_header',
                        {
                            style: author.genres ? ('background-color: ' + get_softer_colour(Authors.get_author_top_genre(author))) : '',
                        },

                        m('.author_tile_title',
                            {
                                class: (author && author.pen_name && author.pen_name.length > 35) ?
                                    ((author.pen_name && author.pen_name.length > 40) ? 'smaller_title' : 'small_title') : ''
                            },
                            author.pen_name || m('.thin_word_shimmer', '-')
                        ),

                        author.full_name ? m('.author_tile_full_name',

                            author.full_name
                        ) : (!author.code ? m('.author_tile_author.thin_word_shimmer', '-') : []),
                    ),

                    m('.tile_line_1'),

                    m('.author_tile_cover_info_section',
                        m('.author_tile_cover',
                            m('.author_tile_image',
                                author.code ? m('img', {

                                    style:
                                        `${(author.profile_pic && author.profile_pic !== true) ? ('object-position:' + author.profile_pic) : ''}
                                        ;
                                        `,
                                    //${Genres.get_style(Genres.list.find(g => g.code == Authors.get_author_top_genre(author)).hue)}

                                    src: (image_base + (author.profile_pic ? author.code : 'blank') + '.jpg'),
                                    alt: author.code ? ('A picture of ' + author.pen_name) : 'A generic silhouette',
                                    loading: 'lazy'
                                }) : [],
                            )
                        ),
                        m('.author_tile_info',

                            m('.author_tile_info_section_1',
                                author.nationality ? m('.author_tile_nationality', author.nationality) : (!author.code ? m('.thin_word_shimmer', '-') : []),
                                author.born ? m('.author_tile_life', author.born.year, ' - ', author.died.year) : (!author.code ? m('.thin_word_shimmer', '-') : m('.author_tile_life', '???', ' - ', '???')),
                            ),

                            m('.author_tile_info_separator'),

                            m(genres_section, { author: author }),
                           
                            m('.author_tile_info_separator'),

                            m('.author_tile_n_works', author.works ? Authors.get_n_works(author) : [m('.thin_word_shimmer', '-')]),

                            m('.author_tile_info_separator'),

                            m('.author_tile_short_description', m('span', author.description)) ,
                        )
                    ),

                    // m('.tile_line_2'),



                    m('.author_tile_quote_section',

                        author.quote ? m('.author_tile_quote',
                            m('i', '“' + author.quote + '”'),
                            author.quote_story_code ? [' - ', m('span', author.quote_story_title)] : []

                        ) : (!author.code ? m('.text_shimmer',
                            [...Array(3)].map(() => [
                                m('.text_shimmer_line_cover')
                            ])
                        ) : []
                        )
                    )
                ),

                m('.author_tile_hanging_buttons',

                    author.code ? m('a.read_button',
                        {
                            href: '/stories?author=' + author.code,
                        },
                        'Stories',

                    ) : [],

                    author.code ? m('a.read_button',
                        {
                            class: vnode.state.hovering_main_tile ? 'active' : '',
                            href: '/author/' + author.code,

                        },
                        m('.di_computer', 'Author'), ' Page'
                    ) : [],
                )
            )
        ]
    }
}


const genres_section = {
    view: vnode => {
        let author = vnode.attrs.author

        return [
            m('.author_tile_genres',
                {
                    // style: author.genres ? `background-color: ${get_soft_colour(Authors.get_author_top_genre(author))}` : '',

                },
                (author.genres ?
                    (Authors.get_author_main_genres({ author: author }))
                    : [{ skeleton: true }, { skeleton: true }])
                    .map(genre => [
                        m(genre_section, { genre: genre })
                    ])
            )
        ]
    }
}


const genre_section = {
    view: vnode => {
        let genre = vnode.attrs.genre
        let genre_object = genre.skeleton ? ({}) : Genres.list.find(g => g.code == genre.toLowerCase())
        return [
            m('.genre_section',
            {
                class: genre == 'adventure' ? 'adventure_shrunk' : ''
            },
                // m('.genre_tile',
                 
                //     !genre.skeleton ? m('img', {
                //         src: image_base + genre_object.small_image + '.jpg',
                //         style: `${Genres.get_style(genre_object.hue)}; ${genre_object.small_image_position ? ('object-position: ' + genre_object.small_image_position) : ''}`,

                //         alt: genre_object.small_image_alt
                //     }) : [],

                //     !genre.skeleton ? m('.image_shade', { style: 'background-color:' + genre_object.colour }) : [],
                //     m('.border')

                // ),
                !genre.skeleton ? capitalise_first(genre) : m('.thin_word_shimmer', '-')
            )
        ]
    }
}


let get_soft_colour = genre => {
    let colour = Genres.list.find(g => g.code == genre).colour

    colour = colour.replace('hsl', 'hsla')
    colour = colour.replace('deg', 'deg,')
    colour = colour.replace('%', '%,')
    colour = colour.replace(')', ', 0.8)')

    return colour
    //.split(')')[0] + ', 0.6)',
}

let get_softer_colour = genre => {
    let colour = Genres.list.find(g => g.code == genre).colour

    colour = colour.replace('hsl', 'hsla')
    colour = colour.replace('deg', 'deg,')
    colour = colour.replace('%', '%,')
    colour = colour.replace(')', ', 0.4)')

    return colour
    //.split(')')[0] + ', 0.6)',
}



export default author_tile